import { type ComponentPropsWithoutRef } from 'react';

import FormValidationError from '../FormValidationError';
import { useControlledField } from './ControlledFieldContext';

const ControlledFieldErrorMessage = (
  props: Omit<ComponentPropsWithoutRef<typeof FormValidationError>, 'message'>
) => {
  const { fieldState } = useControlledField();
  if (!fieldState.error) return null;
  return <FormValidationError message={fieldState.error.message} {...props} />;
};

export default ControlledFieldErrorMessage;
